import React from 'react';
import { HowTo, GlobalLayout } from '../'

const HowToPage = (props) => (
  <GlobalLayout>
    <HowTo {...props} />
  </GlobalLayout>
);

export default HowToPage;